export const SET_BUNDLES = 'SET_BUNDLES'
export const RESET_BUNDLES = 'RESET_BUNDLES'